import { Card, Flex, Icon, Label, Text } from "@gravity-ui/uikit";
import { ComponentState } from "definitions/poizon-bff";

import { statusInfo } from "../../ServiceStatusPage.constants.tsx";
import { AlertRow } from "../AlertRow/AlertRow.tsx";
import { serviceCardInfo } from "./ServiceStatusCard.constants.tsx";
import css from "./ServiceStatusCard.module.scss";

interface ServiceStatusCardProps {
  state: ComponentState;
}

export const ServiceStatusCard = ({ state }: ServiceStatusCardProps) => {
  const { key, status, alerts } = state;
  const cardInfo = serviceCardInfo[key];

  if (!cardInfo) {
    return null;
  }

  const info = statusInfo[status];

  return (
    <Card theme={info.cardTheme} view="outlined" className={css.card}>
      <Flex direction="column" gap={3}>
        <Flex gap={3} alignItems="center">
          <div className={css.logo}>
            <Icon data={cardInfo.icon} size={24} />
          </div>
          <Text variant="subheader-2" className={css.title}>
            {cardInfo.title}
          </Text>
          <Label theme={info.labelTheme} size="m">
            {info.badgeLabel}
          </Label>
        </Flex>
        {alerts.length > 0 && (
          <Flex direction="column" gap={2} className={css.alerts}>
            {alerts.map((alert) => (
              <AlertRow
                key={`${alert.severity}-${alert.since}`}
                alert={alert}
              />
            ))}
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
